import React from "react";

import { PlatformModal } from "@churchofjesuschrist/eden-platform-modal";
import styled from "styled-components";

const StyledModal = styled(PlatformModal)`
    max-width: 95vw;
    max-height: 90vh;
    header{
        display:none;
    }
    
    /* Ensure the modal content is contained and scrollable */
    .modal-content {
        max-height: 85vh;
        overflow-y: auto;
    }
    
    /* Style the modal dialog to be properly sized */
    .modal-dialog {
        max-width: 95vw;
        max-height: 90vh;
        margin: 2.5vh auto;
    }
`;

const HeaderlessModal = ({children, ...props}) => <StyledModal
  open={props.active} {...props}>{children}</StyledModal>

export default HeaderlessModal;
